import styled from "styled-components";
import { COLORS, responsive } from "../../../../../../styles/constants.style";
import {
  fontWeightBold,
  h3Regular,
} from "../../../../../../components/typography/MuiTypography.style";

export const ProjectFeesAndExpenseMainWrapper = styled.div`
  margin-top: 16px;

  .link {
    width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${responsive.MOBILE`
    margin-bottom: 16px;
  `}
  .fees-and-expense-container {
    margin: 16px;
    ${responsive.MOBILE`
      margin: 0px;
      `}
    .add-fee-expense-btns {
      display: flex;
      justify-content: flex-end;
      column-gap: 16px;
      align-items: center;

      .divider {
        width: 1px;
        background-color: ${COLORS.cirrus_black3};
      }

      ${responsive.MOBILE`
        display: flex;
        flex-direction: column-reverse;
        padding: 16px 8px 16px;
        gap: 8px;
        align-items: center;
          button {
            width : 100%;
          }
  `}
    }
  }

  .add-fees-and-expense-general-form {
    margin: 16px;
  }
  .invoice-amount {
    padding: 0px;
    margin: 0px;
    ${responsive.MOBILE`
      padding: 16px 8px;
    `}
  }
`;

export const ProjectAddFeesAndExpenseTabWrapper = styled.div`
  .form-container,
  .radio-container {
    margin: 16px;
    ${responsive.MOBILE`
      margin: 0 16px 0 16px;
    `}
  }
  .summary-header {
    padding: 16px;
    border-bottom: 1px solid ${COLORS.cirrus_black3};
  }
  .summary-table-container {
    .text-right {
      text-align: right;
    }
    margin-top: 16px;
  }
`;

export const ProjectExpenseGenericFormWrapper = styled.div`
  .MuiPickersInputBase-root,
  .date-field {
    width: 100%;
  }
  .form-section {
    &:not(:last-child, :first-child) {
      border-bottom: 1px dashed ${COLORS.primary_light_blue};
    }
    .form-section-header {
      margin-bottom: 16px;
    }
    padding: 16px 8px;
    ${responsive.MOBILE`
      padding: 16px 16px;
    `}
  }
  .form-section-general {
    padding: 16px 8px;
    ${responsive.MOBILE`
      padding: 16px 16px 0 16px;
    `}
  }
  .exchange-rate-input {
    position: relative;
  }

  .convert-link {
    ${h3Regular}
    ${fontWeightBold}
    position: absolute;
    top: 0px;
    text-decoration: underline;
    text-underline-offset: 4px;
    right: 0px;
    color: ${COLORS.primary_light_blue};
  }
`;
